// extracted by mini-css-extract-plugin
export default {"rating":"Oy-z","numberOfStars":"Py-z","count":"Qy-z","barGraphSpacing":"Ry-z","barGraph":"Sy-z"};